import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const ReportScheduleRunSchema = withDefaults({
  type: 'report-schedule-run',
  fields: [
    {
      kind: 'attribute',
      name: 'reportScheduleId',
    },
    {
      kind: 'attribute',
      name: 'reportId',
    },
    {
      kind: 'attribute',
      name: 'companyId',
    },
    {
      kind: 'attribute',
      name: 'reportName',
    },
    {
      kind: 'attribute',
      name: 'status',
    },
    {
      kind: 'attribute',
      name: 'rowCount',
    },
    {
      kind: 'attribute',
      name: 'truncated',
    },
    {
      kind: 'attribute',
      name: 'ranAt',
    },
    {
      kind: 'attribute',
      name: 'downloadUrl',
    },
  ],
});

export default ReportScheduleRunSchema;
